// ─────────────────────────────────────────────────────────────────────────────
// IMPORTANT: This mapping converts individual Tailwind utility class tokens
// to Bootstrap classes. Keys must be SINGLE class names (no spaces).
// Multi-word keys like "container mx-auto" will NEVER match because the
// converter splits classes token by token.
// ─────────────────────────────────────────────────────────────────────────────

const tailwindToBootstrap = {

    // ─── Layout ───────────────────────────────────────────────────────────────
    'container':                    'container',
    // ✅ FIXED: removed multi-word keys 'container mx-auto' etc. — they never matched

    // ─── Display ──────────────────────────────────────────────────────────────
    'flex':                         'd-flex',       // ✅ FIXED: was duplicated (mapped to both 'd-flex' and 'col')
    'inline-flex':                  'd-inline-flex',
    'block':                        'd-block',
    'inline':                       'd-inline',
    'inline-block':                 'd-inline-block',
    'hidden':                       'd-none',
    'grid':                         'd-grid',
    'table':                        'd-table',
    'table-row':                    'd-table-row',
    'table-cell':                   'd-table-cell',

    // ─── Flexbox ──────────────────────────────────────────────────────────────
    'flex-row':                     'flex-row',
    'flex-col':                     'flex-column',
    'flex-row-reverse':             'flex-row-reverse',
    'flex-col-reverse':             'flex-column-reverse',
    'flex-grow-0':                  'flex-grow-0',
    'flex-grow':                    'flex-grow-1',
    'flex-shrink-0':                'flex-shrink-0',
    'flex-shrink':                  'flex-shrink-1',
    'flex-wrap':                    'flex-wrap',
    'flex-nowrap':                  'flex-nowrap',
    'flex-wrap-reverse':            'flex-wrap-reverse',
    'flex-1':                       'flex-fill',
    'justify-start':                'justify-content-start',
    'justify-end':                  'justify-content-end',
    'justify-center':               'justify-content-center',
    'justify-between':              'justify-content-between',
    'justify-around':               'justify-content-around',
    'justify-evenly':               'justify-content-evenly',
    'items-start':                  'align-items-start',
    'items-end':                    'align-items-end',
    'items-center':                 'align-items-center',
    'items-baseline':               'align-items-baseline',
    'items-stretch':                'align-items-stretch',
    'content-start':                'align-content-start',
    'content-end':                  'align-content-end',
    'content-center':               'align-content-center',
    'content-between':              'align-content-between',
    'content-around':               'align-content-around',
    'content-stretch':              'align-content-stretch',
    'self-auto':                    'align-self-auto',
    'self-start':                   'align-self-start',
    'self-end':                     'align-self-end',
    'self-center':                  'align-self-center',
    'self-baseline':                'align-self-baseline',
    'self-stretch':                 'align-self-stretch',

    // ─── Order ────────────────────────────────────────────────────────────────
    'order-none':                   'order-0',
    'order-1':                      'order-1',
    'order-2':                      'order-2',
    'order-3':                      'order-3',
    'order-4':                      'order-4',
    'order-5':                      'order-5',
    'order-6':                      'order-6',
    'order-7':                      'order-7',
    'order-8':                      'order-8',
    'order-9':                      'order-9',
    'order-10':                     'order-10',
    'order-11':                     'order-11',
    'order-12':                     'order-12',
    'order-first':                  'order-first',
    'order-last':                   'order-last',

    // ─── Grid cols — single token only ────────────────────────────────────────
    // NOTE: "w-1/12" alone maps to "col-1". If user also has "px-2" it will
    // appear as a separate /* not found */ comment — that's expected behavior.
    'w-1/12':                       'col-1',
    'w-2/12':                       'col-2',
    'w-3/12':                       'col-3',
    'w-4/12':                       'col-4',
    'w-5/12':                       'col-5',
    'w-6/12':                       'col-6',
    'w-7/12':                       'col-7',
    'w-8/12':                       'col-8',
    'w-9/12':                       'col-9',
    'w-10/12':                      'col-10',
    'w-11/12':                      'col-11',
    'w-full':                       'w-100',
    'w-1/4':                        'w-25',
    'w-1/2':                        'w-50',
    'w-3/4':                        'w-75',
    'w-auto':                       'w-auto',       // ✅ FIXED: was duplicated
    'w-screen':                     'vw-100',

    // ─── Height ───────────────────────────────────────────────────────────────
    'h-1/4':                        'h-25',
    'h-1/2':                        'h-50',
    'h-3/4':                        'h-75',
    'h-full':                       'h-100',
    'h-auto':                       'h-auto',       // ✅ FIXED: was duplicated
    'h-screen':                     'vh-100',
    'min-h-screen':                 'min-vh-100',
    'max-h-full':                   'mh-100',

    // ─── Typography ───────────────────────────────────────────────────────────
    'text-left':                    'text-start',
    'text-center':                  'text-center',
    'text-right':                   'text-end',
    'text-justify':                 'text-justify',
    'lowercase':                    'text-lowercase',
    'uppercase':                    'text-uppercase',
    'capitalize':                   'text-capitalize',
    'font-bold':                    'fw-bold',
    'font-extrabold':               'fw-bolder',
    'font-normal':                  'fw-normal',
    'font-light':                   'fw-light',
    'font-thin':                    'fw-lighter',
    'font-semibold':                'fw-semibold',
    'font-medium':                  'fw-medium',
    'italic':                       'fst-italic',
    'not-italic':                   'fst-normal',
    'font-mono':                    'font-monospace',
    'truncate':                     'text-truncate',
    'underline':                    'text-decoration-underline',
    'no-underline':                 'text-decoration-none',
    'line-through':                 'text-decoration-line-through',
    'whitespace-nowrap':            'text-nowrap',
    'whitespace-normal':            'text-wrap',
    'break-words':                  'text-break',
    // Font sizes
    'text-sm':                      'small',
    'text-base':                    '',
    'text-lg':                      'fs-5',
    'text-xl':                      'fs-4',
    'text-2xl':                     'h4',
    'text-3xl':                     'h3',
    'text-4xl':                     'h2',
    'text-5xl':                     'h1',
    // Line height
    'leading-none':                 'lh-1',
    'leading-tight':                'lh-sm',
    'leading-normal':               'lh-base',
    'leading-loose':                'lh-lg',
    'leading-relaxed':              'lead',

    // ─── Spacing — Margin ─────────────────────────────────────────────────────
    'm-0': 'm-0', 'm-1': 'm-1', 'm-2': 'm-2', 'm-3': 'm-3', 'm-4': 'm-4', 'm-5': 'm-5', 'm-auto': 'm-auto',
    'mt-0': 'mt-0', 'mt-1': 'mt-1', 'mt-2': 'mt-2', 'mt-3': 'mt-3', 'mt-4': 'mt-4', 'mt-5': 'mt-5', 'mt-auto': 'mt-auto',
    'mb-0': 'mb-0', 'mb-1': 'mb-1', 'mb-2': 'mb-2', 'mb-3': 'mb-3', 'mb-4': 'mb-4', 'mb-5': 'mb-5', 'mb-auto': 'mb-auto',
    'ml-0': 'ms-0', 'ml-1': 'ms-1', 'ml-2': 'ms-2', 'ml-3': 'ms-3', 'ml-4': 'ms-4', 'ml-5': 'ms-5', 'ml-auto': 'ms-auto',
    'mr-0': 'me-0', 'mr-1': 'me-1', 'mr-2': 'me-2', 'mr-3': 'me-3', 'mr-4': 'me-4', 'mr-5': 'me-5', 'mr-auto': 'me-auto',
    'mx-0': 'mx-0', 'mx-1': 'mx-1', 'mx-2': 'mx-2', 'mx-3': 'mx-3', 'mx-4': 'mx-4', 'mx-5': 'mx-5', 'mx-auto': 'mx-auto',
    'my-0': 'my-0', 'my-1': 'my-1', 'my-2': 'my-2', 'my-3': 'my-3', 'my-4': 'my-4', 'my-5': 'my-5', 'my-auto': 'my-auto',

    // ─── Spacing — Padding ────────────────────────────────────────────────────
    'p-0': 'p-0', 'p-1': 'p-1', 'p-2': 'p-2', 'p-3': 'p-3', 'p-4': 'p-4', 'p-5': 'p-5',
    'pt-0': 'pt-0', 'pt-1': 'pt-1', 'pt-2': 'pt-2', 'pt-3': 'pt-3', 'pt-4': 'pt-4', 'pt-5': 'pt-5',
    'pb-0': 'pb-0', 'pb-1': 'pb-1', 'pb-2': 'pb-2', 'pb-3': 'pb-3', 'pb-4': 'pb-4', 'pb-5': 'pb-5',
    'pl-0': 'ps-0', 'pl-1': 'ps-1', 'pl-2': 'ps-2', 'pl-3': 'ps-3', 'pl-4': 'ps-4', 'pl-5': 'ps-5',
    'pr-0': 'pe-0', 'pr-1': 'pe-1', 'pr-2': 'pe-2', 'pr-3': 'pe-3', 'pr-4': 'pe-4', 'pr-5': 'pe-5',
    'px-0': 'px-0', 'px-1': 'px-1', 'px-2': 'px-2', 'px-3': 'px-3', 'px-4': 'px-4', 'px-5': 'px-5',
    'py-0': 'py-0', 'py-1': 'py-1', 'py-2': 'py-2', 'py-3': 'py-3', 'py-4': 'py-4', 'py-5': 'py-5',

    // ─── Gap ──────────────────────────────────────────────────────────────────
    'gap-0': 'g-0', 'gap-1': 'g-1', 'gap-2': 'g-2', 'gap-3': 'g-3', 'gap-4': 'g-4', 'gap-5': 'g-5',

    // ─── Position ─────────────────────────────────────────────────────────────
    'static':                       'position-static',
    'relative':                     'position-relative',
    'absolute':                     'position-absolute',
    'fixed':                        'position-fixed',
    'sticky':                       'position-sticky',
    'top-0':                        'top-0',
    'bottom-0':                     'bottom-0',
    'left-0':                       'start-0',
    'right-0':                      'end-0',

    // ─── Visibility ───────────────────────────────────────────────────────────
    'visible':                      'visible',
    'invisible':                    'invisible',
    'sr-only':                      'visually-hidden',

    // ─── Overflow ─────────────────────────────────────────────────────────────
    'overflow-auto':                'overflow-auto',
    'overflow-hidden':              'overflow-hidden',
    'overflow-visible':             'overflow-visible',
    'overflow-scroll':              'overflow-scroll',

    // ─── Shadows ──────────────────────────────────────────────────────────────
    'shadow-none':                  'shadow-none',
    'shadow-sm':                    'shadow-sm',
    'shadow':                       'shadow',
    'shadow-lg':                    'shadow-lg',

    // ─── Borders ──────────────────────────────────────────────────────────────
    'border':                       'border',
    'border-0':                     'border-0',
    'border-t':                     'border-top',
    'border-b':                     'border-bottom',
    'border-l':                     'border-start',
    'border-r':                     'border-end',
    'rounded-none':                 'rounded-0',
    'rounded-sm':                   'rounded-1',
    'rounded':                      'rounded',
    'rounded-lg':                   'rounded-3',
    'rounded-full':                 'rounded-pill',

    // ─── Floats ───────────────────────────────────────────────────────────────
    'float-left':                   'float-start',
    'float-right':                  'float-end',
    'float-none':                   'float-none',

    // ─── Opacity ──────────────────────────────────────────────────────────────
    'opacity-0':                    'opacity-0',
    'opacity-25':                   'opacity-25',
    'opacity-50':                   'opacity-50',
    'opacity-75':                   'opacity-75',
    'opacity-100':                  'opacity-100',

    // ─── Colors — Text ────────────────────────────────────────────────────────
    'text-white':                   'text-white',
    'text-black':                   'text-dark',
    'text-blue-600':                'text-primary',
    'text-gray-500':                'text-secondary',
    'text-green-600':               'text-success',
    'text-red-600':                 'text-danger',
    'text-yellow-500':              'text-warning',
    'text-cyan-600':                'text-info',
    'text-gray-300':                'text-light',
    'text-gray-900':                'text-dark',
    'text-gray-400':                'text-muted',

    // ─── Colors — Background ──────────────────────────────────────────────────
    'bg-white':                     'bg-white',
    'bg-black':                     'bg-dark',
    'bg-transparent':               'bg-transparent',
    'bg-blue-600':                  'bg-primary',
    'bg-gray-500':                  'bg-secondary',
    'bg-green-500':                 'bg-success',
    'bg-red-500':                   'bg-danger',
    'bg-yellow-400':                'bg-warning',
    'bg-cyan-500':                  'bg-info',
    'bg-gray-100':                  'bg-light',
    'bg-gray-900':                  'bg-dark',
    'bg-gradient-to-r':             'bg-gradient',

    // ─── Buttons ──────────────────────────────────────────────────────────────
    'cursor-pointer':               '',
    'transition-colors':            '',

    // ─── Sizing ───────────────────────────────────────────────────────────────
    'aspect-video':                 'ratio ratio-16x9',
    'aspect-square':                'ratio ratio-1x1',
    'object-contain':               'object-fit-contain',
    'object-cover':                 'object-fit-cover',
    'object-fill':                  'object-fit-fill',
    'object-none':                  'object-fit-none',
    'max-w-full':                   'mw-100',

    // ─── Utilities ────────────────────────────────────────────────────────────
    'clearfix':                     'clearfix',
    'overflow-x-auto':              'table-responsive',
    'animate-spin':                 '',
    'animate-pulse':                '',
    'z-0':                          'z-0',
    'z-10':                         'z-1',
    'z-20':                         'z-2',
    'z-30':                         'z-3',
    'z-40':                         '',
    'z-50':                         '',
};

export default tailwindToBootstrap;